// API endpoints configuration
// Note: All API configurations are now centralized in clientConfig.js
// Import getApiUrl from clientConfig to build dynamic URLs

import { getApiUrl as buildApiUrl } from './clientConfig';

const apis = {
  // Helper function to get full API URL for form submission
  getApiUrl: (clientConfig) => {
    return buildApiUrl(clientConfig, 'submitForm');
  },

  // Helper function to get cities API URL
  getCitiesUrl: (clientConfig) => {
    return buildApiUrl(clientConfig, 'getCities');
  },

  // Helper function to get areas API URL
  getAreasUrl: (clientConfig) => {
    return buildApiUrl(clientConfig, 'getAreas');
  },

  // Helper function to get courses API URL
  getCoursesUrl: (clientConfig) => {
    return buildApiUrl(clientConfig, 'getCourses');
  }
};

export default apis;
